import { CommunicationLimitsTable } from "features/communicationLimitsTable";
import Content from "layouts/agencyPortal/dashboard/content";
import PageLayout from "layouts/agencyPortal/dashboard/pageLayout";

function CommunicationLimitsPage() {
  return (
    <PageLayout>
      <Content>
        <CommunicationLimitsTable />
      </Content>
    </PageLayout>
  );
}

export default CommunicationLimitsPage;
